export default "__VITE_ASSET__GcB_d2eY__"